import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/psx-frontend/psx-frontend/components/BusinessNewsClient.tsx");
